import { createAsyncThunk } from "@reduxjs/toolkit"
import { fetchBackend } from "@/core/apis/backend"

export interface BenchmarkAccountRow {
  id: string
  account: string
  sector: string | null
  size: number | null
  isDeleted: boolean
}

//Archived accounts available for sector assignment, regardless of eNPS participation or bank setup.
export const fetchBenchmarkAccounts_AsSupervisor = createAsyncThunk(
  "benchmarkAccount/fetchAsSupervisor",
  async () => {
    const res = await fetchBackend({ url: "/supervisor/benchmark/accounts" })
    if (res.error) throw new Error(res.error)
    return res as BenchmarkAccountRow[]
  }
)

export interface PurgeBenchmarkAccountsResult {
  deletedIds: string[]
  skippedIds: string[]
  deletedFacts: number
  benchmarksInvalidated: boolean
}

export const purgeBenchmarkAccounts_AsSupervisor = createAsyncThunk(
  "benchmarkAccount/purgeAsSupervisor",
  async (accountIds: string[]) => {
    const res = await fetchBackend({ url: "/supervisor/benchmark/accounts/purge", method: "POST", data: { accountIds } })
    if (res.error) throw new Error(res.error)
    return res as PurgeBenchmarkAccountsResult
  }
)
